<template>
  <div class="feature-row">
    <div class="search-row">
      <div class="left-part">
        <el-input v-model="queryForm.keyword" class="search-input" placeholder="关键字搜索">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select v-model="queryForm.abiBrandId" placeholder="按品牌" clearable>
          <el-option
            v-for="item in brandList"
            :label="item.abiBrandName"
            :value="item.abiBrandId"
            :key="item.abiBrandId"
          />
        </el-select>
        <!-- <span class="search-text">价格区间</span>
        <el-input v-model="queryForm.minPrice" class="price-input"></el-input>
        <span class="search-text">至</span>
        <el-input v-model="queryForm.maxPrice" class="price-input"></el-input> -->
        <el-button type="danger" class="btn-red" @click="handleFilter">搜索</el-button>
      </div>
      <div class="right-part">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import baseApi from '@/api/base'
export default {
  name: 'freezer-search-row',
  data () {
    return {
      brandList: [],
      queryForm: {
        abiBrandId: '',
        minPrice: '',
        maxPrice: ''
      }
    }
  },
  computed: {
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getBrand()
    },
    // 品牌
    getBrand () {
      baseApi.getBrand().then(res => {
        if (res.data.resultCode === '0') {
          this.brandList = res.data.resultData.brandList
        }
      })
    },
    // 搜索
    handleFilter () {
      this.$emit('handleFilter', this.queryForm)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  height: 36px;
  line-height: 36px;
  display: flex;
  justify-content: space-between;
  .search-input.el-input {
    width: 180px;
    height: 36px;
    margin-right: $content-middle;
    input::-webkit-input-placeholder {
      color: #000;
    }
  }
  .price-input.el-input {
    width: 50px;
  }
  .search-text {
    font-size: $font-12;
    display: inline-block;
    height: 34px;
    padding: 0 5px;
    background-color: #d8d8d8;
  }
}
.el-select {
  width: 110px;
  height: 36px;
}
.el-button {
  height: 36px;
  margin-left: 10px;
}
.right-part {
  display: flex;
}
.feature-row {
  margin-bottom: $content-middle;
}
</style>
